import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider, Theme, StyledEngineProvider } from '@mui/material/styles';
import { GlobalTheme } from '~/_base/apeMuiTheme';
import InlineHelp from '~/_base/components/inlineHelp';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}


/**
 * A custom hook for injecting <InlineHelp /> into a rails view
 * Searches for any divs with classname 'ape-inline-help-injection'
 * and renders <InlineHelp /> along with the necessary style
 */
export default function UseInlineHelp() {
  useEffect(() => {
    function injectIfFound() {
      const helpElements = document.getElementsByClassName(
        'ape-inline-help-injection'
      );

      if (!helpElements) return;

      var style = document.createElement('style');
      style.innerHTML = `
      .ape-inline-help-injection {
        display: inline-block;
      }`;
      document.head.appendChild(style);

      if (helpElements) {
        const elementsArray = Array.from(helpElements);
        elementsArray.forEach(element => {
          const helpkey = element.getAttribute('data-helpkey');
          ReactDOM.render(
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={GlobalTheme}>
                <InlineHelp helpkey={helpkey || ''} />
              </ThemeProvider>
            </StyledEngineProvider>,
            element
          );
        });
      }
    }

    injectIfFound();
  }, []);
}
